import { render, staticRenderFns } from "./AddCampaignSubmission.vue?vue&type=template&id=005164b4&"
import script from "./AddCampaignSubmission.vue?vue&type=script&lang=js&"
export * from "./AddCampaignSubmission.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaignSubmission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports